(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arlishco-mobile-sticky-atc"]) return;
  try {
    
  (() => {
    const MOBILE_QUERY = '(max-width: 749px)';

    const init = () => {
      const bar = document.querySelector('[data-arl-mobile-sticky-atc]');
      const productRoot = document.querySelector('product-info[id^="MainProduct-"]');

      if (!bar || !productRoot || bar.dataset.arlReady === 'true') return;

      bar.dataset.arlReady = 'true';

      const stickyButton = bar.querySelector('[data-arl-sticky-submit]');
      const stickyLabel = bar.querySelector('[data-arl-sticky-label]');
      const stickyPrice = bar.querySelector('[data-arl-sticky-price]');
      const mobileMedia = window.matchMedia(MOBILE_QUERY);

      let mainButton = null;
      let frame = null;

      const getMainButton = () =>
        productRoot.querySelector('product-form .product-form__submit');

      const getPriceSource = () =>
        productRoot.querySelector(
          '[id^="price-"] .price__sale .price-item--sale, [id^="price-"] .price__regular .price-item--regular, [id^="price-"] .price-item--regular'
        );

      const getButtonLabel = (button) => {
        if (!button) return '';

        const soldOut = button.querySelector('.sold-out-message:not(.hidden)');
        if (soldOut?.textContent.trim()) return soldOut.textContent.trim();

        const primary = Array.from(button.querySelectorAll('span')).find(
          (span) =>
            !span.classList.contains('sold-out-message') &&
            !span.classList.contains('loading__spinner') &&
            !span.classList.contains('hidden') &&
            span.textContent.trim()
        );

        return primary?.textContent.trim() || 'Add to cart';
      };

      const syncState = () => {
        mainButton = getMainButton();

        if (!mainButton || !stickyButton) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
          return;
        }

        const isLoading = mainButton.classList.contains('loading');
        const isDisabled =
          mainButton.disabled ||
          mainButton.getAttribute('aria-disabled') === 'true';

        stickyButton.disabled = isDisabled || isLoading;

        if (stickyLabel) {
          stickyLabel.textContent = isLoading
            ? 'Adding…'
            : getButtonLabel(mainButton);
        }

        const priceSource = getPriceSource();
        if (stickyPrice && priceSource?.textContent.trim()) {
          stickyPrice.textContent = priceSource.textContent.trim();
        }
      };

      const updateVisibility = () => {
        frame = null;
        syncState();

        if (!mobileMedia.matches || !mainButton) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
          return;
        }

        const rect = mainButton.getBoundingClientRect();
        const shouldShow = rect.bottom < 0;

        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      const scheduleUpdate = () => {
        if (frame !== null) return;
        frame = window.requestAnimationFrame(updateVisibility);
      };

      stickyButton?.addEventListener('click', () => {
        const target = getMainButton();
        if (
          !target ||
          target.disabled ||
          target.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        target.click();
        scheduleUpdate();
      });

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });

      if (mobileMedia.addEventListener) {
        mobileMedia.addEventListener('change', scheduleUpdate);
      } else {
        mobileMedia.addListener(scheduleUpdate);
      }

      const observer = new MutationObserver(scheduleUpdate);
      observer.observe(productRoot, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled'],
      });

      scheduleUpdate();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, activeObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        activeObserver.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener('open', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
  }, true);

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
